export default function hasFailureReadPermissions(permissions, environment) {
  return permissions && permissions.orderManagement
    ? !!permissions.orderManagement.find(
        p =>
          (p.identifier === environment || p.identifier === '*') &&
          p.permissions.includes('read:order-remediation:failures')
      )
    : false;
}
